import React from 'react';

const warrantyFaqStatic = {
  header: {
    title: 'Frequently asked questions',
    shortDescription: <p>Have a Q? Find your A below.</p>,
  },
  faqItems: [
    {
      heading: 'General',
      content: [
        {
          title: 'What is your warranty?',
          details: (
            <>
              <p>
                Each Mila purchased directly from the Mila website or from an
                authorized seller (
                <a
                  href='https://www.amazon.com/'
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  Amazon.com
                </a>
                {' '}
                in the US, Best Buy, The Home Depot) is officially covered by a
                12-month (one-year) standard warranty. We have now extended this
                to a 24-month (two-year) warranty for all Mila units.
              </p>
              <p>
                <strong>For Auto-Refill subscribers:</strong>
                {' '}
                If you are an
                Auto-Refill subscriber in good standing, you’ll automatically
                receive another year of warranty coverage, extending it to three
                years in total. Furthermore, should anything go awry after the
                three-year mark, you’re eligible for a $99 replacement unit for
                up to two additional years.
              </p>
              <p>
                Please note that disassembling your Mila unit in any way will
                void the warranty. If you encounter any issues or have questions
                about your warranty coverage, please don’t hesitate to reach out
                to us at
                {' '}
                <a href='mailto:support@milacares.com'>support@milacares.com</a>
                .
              </p>
            </>
          ),
        },
      ],
    },
    {
      heading: 'Auto-Refill Benefits',
      content: [
        {
          title:
            'What additional warranty benefits do Auto-Refill subscribers receive?',
          details: (
            <>
              <p>
                If you are on Auto-Refill you will automatically get another year of coverage (that's 36 months total) as long as you remain a subscriber in good standing. Being in good standing means you have an active Auto-Refill subscription, and have ordered at least one filter in the last 12 months. You'll also want to make sure that your payment methods are up to date. Regular filter replacements are a key part of keeping your air – and your Mila – running in tip top shape.
              </p>
              <p>
                If you're on Auto-Refill and experience any warranty-covered issues after the 36-month mark, and up to 60 months, you can get a replacement unit for:
              </p>
              <ul>
                <li>
                  United States: $99 USD
                </li>
                <li>
                  Canada: $149 CAD
                </li>
              </ul>
              <p>
                Please note that this extended coverage (years 3–5) applies to the US and Canada only. Customers in other regions are covered under our standard 2-year warranty. If you're outside these regions and your unit is experiencing issues, please reach out to us at
                {' '}
                <a href='mailto:support@milacares.com'>support@milacares.com</a>
                {' '}
                and we'll find the best way forward.
              </p>
            </>
          ),
        },
        {
          title:
            'How do I become an Auto-Refill subscriber to qualify for extended warranty coverage?',
          details: (
            <>
              <p>
                Whenever you purchase a Mila directly from us, you'll always have an option to activate your Auto-Refill. In addition to immediate savings, this ensures you'll get a fresh, new filter every six months, keeping your Mila running in tip-top shape. You'll also enjoy an extended 12 months of warranty coverage as long as you keep that Auto-Refill active, increasing your coverage to 36 months from the time of purchase.
              </p>
              <p>If anything happens in years four and five, we'll replace your Mila for a discounted fee — $99 USD in the US ($149 CAD in Canada). Please note this extended coverage is only available in the US and Canada right now.</p>
              <p>
                If you're not sure about the status of your current Mila, you can check at any time through
                {' '}

                <a
                  href='https://account.milacares.com/'
                  target='_blank'
                  rel='noreferrer'
                >
                  My Account
                </a>
                .
              </p>
            </>
          ),
        },
        {
          title:
            'What happens if I’m an Auto-Refill subscriber and I cancel my subscription?',
          details: (
            <>
              <p>
                If you cancel your Auto-Refill, you'll no longer be eligible for the extended third year of coverage or the discounted replacement offer for years four and five. The standard two-year warranty will still apply from the time of purchase.
                {' '}
              </p>

              <p>
                Please note that the extended warranty benefits described above apply to subscribers in the US and Canada. Customers in other regions are covered under the standard two-year warranty regardless of Auto-Refill status.
              </p>
            </>
          ),
        },
      ],
    },
    {
      heading: 'Claiming Warranty',
      content: [
        {
          title: 'How do I claim a warranty for my Mila unit?',
          details: (
            <p>
              To start a warranty claim,
              {' '}
              <a href='https://milamarketing.typeform.com/to/u1aEP1qs#email=xxxxx&ticketid=xxxxx&concern=xxxxx&status=xxxxx' target='_blank' rel='noreferrer'>fill out our warranty claim form</a>
              .
              {' '}
              The form takes approximately 10 minutes and will ask for your contact information, MAC address (found in the Mila app under Account → Technical Info), order details, and a description of what you're experiencing. A video may be requested in some cases.
            </p>
          ),
        },
        {
          title: 'Can I claim a warranty without proof of purchase?',
          details: (
            <ul>
              <li>
                While we do require proof of purchase to process warranty
                claims, we understand that it may not always be available (e.g.,
                if your Mila was a gift). If you can't find your receipt or
                order confirmation, please contact us at
                {' '}
                <a href='mailto:mailto:support@milacares.com'>
                  support@milacares.com
                </a>
                . We will do our best to assist you and explore all possible
                solutions, but please be prepared to provide some basic details
                about the original purchase(r) such as name and/or email to help
                verify the order. Please note that this policy only applies to
                Mila units purchased directly from the Mila website or
                authorized sellers (Amazon where either Mila USA Inc. or Amazon
                is the seller, The Home Depot, Best Buy).
              </li>
            </ul>
          ),
        },
      ],
    },
    {
      heading: 'Extended Warranty Coverage ',
      content: [
        {
          title: 'What is involved with extended warranty?',
          details: (
            <p>
              For Auto-Refill subscribers in the United States and Canada who experience any warranty-covered issues beyond their 36-month coverage, you can get a replacement unit for $99 USD (and $149 CAD in Canada), which represents a significantly discounted rate for a new unit.
              {' '}
            </p>
          ),
        },
        {
          title: 'Is there any warranty on replacement units I pay for?',
          details: (
            <>
              <p>
                Any replacements that you pay for under this extended warranty
                program is covered by a 6-month warranty for defects in
                materials or workmanship.
              </p>
              <p>
                If the replacement is issued within the standard warranty
                period, the remaining duration of that warranty will continue to
                apply to the replacement unit. If you’re on Auto-Refill, this is
                36 months as long as you remain an Auto-Refill subscriber in
                good standing. Otherwise, the standard warranty period is 24
                months. In any case, if you ever have any questions about your
                Mila, even after the warranty period, please do not hesitate to
                contact us at
                {' '}
                <a href='mailto:support@milacares.com'>support@milacares.com</a>
                .
              </p>
            </>
          ),
        },
      ],
    },
    {
      heading: 'Miscellaneous',
      content: [
        {
          title: 'Can I transfer my warranty if I gift my Mila? ',
          details: (
            <ul>
              <li>
                Yes, if you gift your Mila, you can also transfer the warranty,
                provided that the original proof of purchase is available and
                the warranty period has not expired.
              </li>
            </ul>
          ),
        },
        {
          title:
            'My Mila stopped working but I’m outside of the warranty period. What are my options?',
          details: (
            <>
              <p>
                If your Mila stops working after the warranty period, you can still contact our Care Squad at

                {' '}
                <a href='mailto:support@milacares.com'>support@milacares.com</a>
                {' '}

                for assistance.
              </p>
              <p>Standard warranty coverage is 24 months for all customers. For Auto-Refill subscribers in the United States and Canada, coverage extends to 36 months, with a discounted upgrade option available through 60 months.</p>
              <p>Customers in other regions are covered under the standard 2-year warranty. If your unit is outside that window, please get in touch — we’d still love to help.</p>
            </>
          ),
        },
      ],
    },
  ],
};

export default warrantyFaqStatic;
